
import {  createSlice } from "@reduxjs/toolkit"
import {  stateEnum } from "../constants/enum"
const { creditDebitNote } = stateEnum

let initialState = {
  billno: "",
  acid: "",
  detailParams: [],
  isCreditNote: false,
  isNewEntry: true,
}

const creditDebitNoteSlice = createSlice({
  name: creditDebitNote,
  initialState,
  reducers: {
    setIsCreditNote: (state, action) => {
      state.isCreditNote = action.payload
    },
    resetValues: (state) => {
      state.billno = ""
      state.acid = ""
      state.detailParams = []
      state.isCreditNote = false
      state.isNewEntry = true
    },
    setNewEntryMode: (state, action) => {
      state.isNewEntry = action.payload
    },
    setDetailParams: (state, action) => {
      state.detailParams = action.payload
    },
    resetDetailParams: (state) => {
      state.detailParams = []
      state.isNewEntry = true
      state.isCreditNote = false
      state.billno = ""
      state.acid = ""

    },
  },

})

export const {
  setIsCreditNote,
  resetValues,
  setNewEntryMode,
  setDetailParams,
  resetDetailParams
} = creditDebitNoteSlice.actions
export default creditDebitNoteSlice.reducer

